import React from 'react'
import { XMarkIcon } from '@heroicons/react/24/solid'
import useTranslation from 'next-translate/useTranslation'
import styles from './styles.module.scss'

interface IProps {
  handleVisibleChange: any
  isVisible: boolean
  children?: React.ReactNode
  className?: string
}

const CompanyFiltersRwdWrapper = ({
  handleVisibleChange,
  isVisible,
  children,
  className,
}: IProps) => {
  const { t } = useTranslation()

  return (
    <div
      className={`md:container md:mt-10 pb-6 bg-gray-bg z-10  ${
        styles.filters__wrapper
      } ${
        isVisible ? styles['filters--visible'] : styles['filters--rwd-hidden']
      } ${className}`}
    >
      <div
        className={`${styles['filters__close-wrapper']} ${
          isVisible ? styles.isVisible : styles.isHidden
        }`}
      >
        <button
          className={styles.filters__close}
          onClick={handleVisibleChange}
          type='button'
          title={t('common:close')}
        >
          <XMarkIcon width={24} className='max-w-2xl' />
        </button>
      </div>
      {children}
    </div>
  )
}

export default CompanyFiltersRwdWrapper
